import React from "react";
// import AltindagSidebar from "../Sidebar/AltindagSidebar";
// import AltindagOtherServices from "../ServiceAreas/AltindagServiceAreas";
import BadgeSection from "../../BadgeSection";

const AltindagIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      {/* Breadcrumb */}
      <div className="text-sm text-gray-600 mb-4">
        <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp; <span className="underline">Hizmet Bölgeleri</span> &nbsp;&gt;&nbsp; Altındağ
      </div>

      {/* Başlık */}
      <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">ALTINDAĞ HALI VE KOLTUK YIKAMA</h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* Sol sidebarlar */}
        <div className="space-y-6">
          {/* <AltindagSidebar />
          <AltindagOtherServices /> */}
        </div>

        {/* İçerik */}
        <div className="md:col-span-2 space-y-6">
          <p>
            **Altındağ’da hijyenik ve profesyonel halı-koltuk yıkama hizmetleriyle evinize temizlik ve konfor getiriyoruz!**  
            Abone Halı Yıkama **derinlemesine hijyen sağlayan teknolojilerle** evinizde sağlıklı bir ortam oluşturmanıza yardımcı olur.
          </p>

          <p>
            **Altındağ’ın tüm mahallelerinde mobil servisimiz** ile **yerinden alım ve teslimat** hizmeti sunuyoruz.  
            **Beşikkaya, Karapürçek, Gültepe, Aydınlıkevler, Battalgazi** gibi bölgelerde **hızlı temizlik çözümleri** sağlıyoruz.
          </p>

          <h2 className="text-lg font-semibold text-[#003132]">Altındağ'da NedenAbone Halı Yıkama?</h2>
          <ul className="list-disc list-inside">
            <li>**Özel buhar ve vakum sistemleri** – Derinlemesine temizlik</li>
            <li>**Antibakteriyel ve hijyen garantisi** – Sağlıklı ortam sağlıyoruz</li>
            <li>**Leke çıkarma garantisi** – En zorlu lekeler bile temizlenir</li>
            <li>**Halı ve koltuk kumaşına zarar vermeyen sistemler**</li>
            <li>**Yerinde yıkama & fabrikada derinlemesine yıkama** seçenekleri</li>
          </ul>

          <p>
            **Mobil servis sayesinde** Altındağ’ın **her bölgesine hızlı hizmet** sunuyoruz.  
            Buhar ve vakum teknikleriyle yapılan temizlik, **kir ve alerjenleri tamamen yok eder**.
          </p>

          <p>
            **Ev tekstili yıkama hizmetleri:**  
            Yorgan, perde, battaniye gibi ürünleri **antibakteriyel yıkama** ile temizleyerek evinizde daha sağlıklı bir ortam sağlıyoruz.
          </p>

          <p>
            **Altındağ'ın her bölgesine zahmetsiz temizlik garantisiyle hizmet veriyoruz!**  
            Hemen <strong>İletişim</strong> sayfamızdan bize ulaşarak sipariş verebilir veya fiyat bilgisi alabilirsiniz!
          </p>
        </div>

        {/* Rozetler */}
        <div className="space-y-6">
          <BadgeSection />
        </div>
      </div>
    </div>
  );
};

export default AltindagIntro;
